export interface PcpEmailEligibilityData {
  email?: string;
  pcpId?: string;
  corpMPin?: string;
  hasPcpEmailEligibility?: boolean;
}

export interface PcpEmailEligibilityState {
  pcpEmailEligibilityData: PcpEmailEligibilityData;
  setPcpEmailEligibilityData: (values: PcpEmailEligibilityData) => void;
  clearPcpEmailEligibilityData: () => void;
  status: STATUS;
  setStatus: (value: STATUS) => void;
}
export enum STATUS {
  LOADING,
  SUCCESS,
  ERROR,
  IDLE,
}

export enum StoreKeys {
  PCP_EMAIL_ELIGIBILITY_DATA = 'pcpEmailEligibilityData',
  SET_PCP_EMAIL_ELIGIBILITY_DATA = 'setPcpEmailEligibilityData',
  CLEAR_PCP_EMAIL_ELIGIBILITY_DATA = 'clearPcpEmailEligibilityData',
  STATUS = 'status',
  SET_STATUS = 'setStatus',
}

export const initialState = {
  [StoreKeys.PCP_EMAIL_ELIGIBILITY_DATA]: {},
  [StoreKeys.STATUS]: STATUS.IDLE,
};
